import { Typography } from 'antd';
import { noop } from 'lodash';
import React, { useState } from 'react';
import AppSearchInput from './AppSearchInput';
import { useModalState } from '../hooks/useModalState';
import POSearchModal from './POSearch';

export type POSelectedType = {
  poid?: number;
  poreference?: string;
  clientname?: string;
};

export type POSelectProps = {
  onChange?: any;
  value?: POSelectedType;
  phase?: string;
  onlyPoid?: boolean;
};

const PoSelect = ({
  onChange = noop,
  value,
  phase,
  onlyPoid,
}: POSelectProps) => {
  const [Params, setParams] = useState<POSelectedType>({
    poid: value?.poid,
    poreference: value?.poreference,
    clientname: value?.clientname,
  });

  const { visible, close, open } = useModalState(false);
  const handleSelect = (item: any) => {
    onlyPoid ? onChange(item?.poid) : onChange(item);

    setParams({
      poreference: item?.poreference,
      clientname: item.clientname,
      poid: item?.poid,
    });
    close();
  };

  return (
    <>
      <AppSearchInput
        onSearch={open}
        value={
          <Typography.Link>
            {!value?.poid
              ? Params?.poid
                ? `${Params.poreference ?? ''}  -  ${Params.clientname ?? ''}`
                : 'Select an Purchase order'
              : value?.poid
              ? `${value.poreference ?? ''}  -  ${value.clientname ?? ''}`
              : 'Select an Purchase order'}
          </Typography.Link>
        }
      />
      <POSearchModal setPo={handleSelect} visible={visible} onCancel={close} />
    </>
  );
};

export default PoSelect;
